<template>
  <div>
    <v-dialog v-model="dialog" width="500" scrollable>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-if="selectedLensType"
          color="primary"
          v-bind="attrs"
          v-on="on"
          text
          x-small
        >
          <v-icon small color="primary" class="mr-2" x-small>mdi-pencil</v-icon>
          Switch Calc Type
        </v-btn>

        <v-btn v-else color="#FFFFFF" v-bind="attrs" v-on="on" depressed>
          Select Calculation Type
        </v-btn>
      </template>

      <v-card>
        <div class="orangeCardTitle pa-4 d-flex flex-row align-start">
          <div class="d-flex flex-row flex-wrap">
            <div class="pr-4 mb-2 title">Select Calculation Type</div>
            <v-btn
              small
              depressed
              color="#ffffff"
              class="mr-4"
              @click.stop="adviceDialog = true"
            >
              Advice
              <v-icon small color="primary" class="ml-2"
                >mdi-lightbulb</v-icon
              ></v-btn
            >
          </div>
          <v-spacer></v-spacer>

          <v-btn icon text @click="dialog = false">
            <v-icon color="primary">mdi-close</v-icon></v-btn
          >
        </div>

        <v-card-text>
          <div
            v-for="calcGroup in calcGroups"
            :key="calcGroup.group"
            class="my-4"
          >
            <div class="title d-flex flex-row">
              <v-img
                max-width="30"
                max-height="30"
                contain
                :src="calcGroup.icon"
                class="mr-2"
              ></v-img>
              {{ calcGroup.name }}
            </div>
            <v-divider></v-divider>
            <div class="mt-2 mb-3">
              <div v-for="lensKey in calcGroup.items" :key="lensKey">
                <v-btn
                  text
                  color="primary"
                  class="mx-2"
                  @click="
                    $emit('lensType', lensKey);
                    dialog = false;
                  "
                  >{{ calcOptions[lensKey].name }}</v-btn
                >
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <cl-calcs-advice
      v-if="calcGroups"
      :calcGroups="calcGroups"
      :calcOptions="calcOptions"
      :dialog="adviceDialog"
      :eye="eye"
      :rxObjects="rxObjects"
      :kObjects="kObjects"
      :calcResults="calcResults"
      @close="adviceDialog = false"
      @lensType="
        $emit('lensType', $event);
        adviceDialog = false;
      "
    ></cl-calcs-advice>
  </div>
</template>

<script>
// import Name from "../dir/file";
import StyleUtilities from "@/assets/js/StyleUtilities";
import ClCalcsAdvice from "@/components/calcsStuff/ClCalcs/ClCalcsAdvice";

export default {
  name: "ClCalcTypePicker",
  props: {
    calcOptions: null,
    calcGroups: null,
    selectedLensType: null,
    calcResults: null,
    rxObjects: null,
    kObjects: null,
    eye: null,
  },
  components: {
    ClCalcsAdvice,
  },
  mixins: [StyleUtilities],
  data: function () {
    return {
      dialog: false,
      adviceDialog: false,
      choices: { od: null, os: null },
    };
  },
  methods: {
    iconForScore(score) {
      let rtn = "thumbs-up-down";
      if (score >= 8) rtn = "thumb-up";
      if (score <= 6) rtn = "thumb-down";
      return rtn;
    },
    scoreColor(scoreNum) {
      let percent = scoreNum / 10;
      return this.percentageToHsl(percent, 0, 120);
    },
  },
  computed: {},
};
</script>

<style scoped></style>
